import React, {useMemo} from "react";
import ReactModal from "react-modal";
import { useQueryClient} from "@tanstack/react-query";
import { Draggable} from "@components";
import { post } from "@utils/axios_api";
function LectureInstructorModal({isOpen, onClose, onSuccess, insList}) {
  const queryClient = useQueryClient();
  const position = Draggable({ isOpen, dragHandle: ".modal-header" });
  const containerStyle = {
    maxWidth: "1000px",
    minWidth: "1000px",
    maxHeight: "700px",
    minHeight: "700px",
    transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`
  };

  const grouped = useMemo(() => {
    if (!Array.isArray(insList) || insList.length === 0) return {};
    return insList.reduce((acc, row) => {
      (acc[row.eduDt] = acc[row.eduDt] || []).push(row);
      return acc;
    }, {});
  }, [insList]);

  const handleCheckboxChange = async (lectureId, eduDt, instructorId, classNoList, isChecked, e) => {
    if(isChecked){
      if(!window.confirm('실적 반영 하시겠습니까?')) {
        e.target.checked = false;
        return;
      }
      const response = await post('/admin/lectureAttend/result', {
        lectureId,
        eduDt,
        instructorId,
        classNoList,
        instructYn: 'Y'
      });
      alert(response.message);
    } else {
      if (!window.confirm('실적 체크를 해제하시겠습니까?')) {
        e.target.checked = true;
        return;
      }
      const response = await post('/admin/lectureAttend/result', {
        lectureId,
        eduDt,
        instructorId,
        classNoList,
        instructYn: 'N'
      });
      alert(response.message);
    }
    queryClient.invalidateQueries(["selectAdminInsResultList"]);
    
  };


  const renderSchedule = (date, list) => {
    // 현재 idx부터 같은 강사가 몇 행 이어지는지 계산
    const getSpan = (start) => {
      let span = 1;
      while (
        start + span < list.length &&
        list[start + span].combineInsNm === list[start].combineInsNm
      ) {
        span += 1;
      }
      return span;
    };
  
    return (
      <div key={date} style={{ marginTop: 16 }}>
        <h3 className="schedule-title">
          <span className="icon-squares" /> {date}
        </h3>
  
        <table className="table-write schedule-table" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "8%" }}>교시</th>
              <th>과목</th>
              <th style={{ width: "22%" }}>시간</th>
              <th style={{ width: "22%" }}>강사</th>
              <th style={{ width: "22%" }}>실적체크</th>
            </tr>
          </thead>
          <tbody>
            {list.map((c, idx) => {
              const isFirst =
                idx === 0 ||
                list[idx - 1].combineInsNm !== c.combineInsNm;
              const span = isFirst ? getSpan(idx) : 0; 
  
              return (
                <tr key={`${date}-${c.classNo}`}>
                  <td>{c.classNo}</td>
                  <td>{c.subject}</td>
                  <td>{`${c.startTm.slice(0, 2)}:${c.startTm.slice(2, 4)} ~ ${c.endTm.slice(0, 2)} : ${c.endTm.slice(2, 4)}`}</td>
                  {isFirst && <td rowSpan={span}>{c.combineInsNm}</td>}
                  {isFirst && <td rowSpan={span}>
                    <input type="checkbox" 
                      defaultChecked={c.instructYn === 'Y'} 
                      onChange={(e) => 
                      handleCheckboxChange(
                        c.lectureId, c.eduDt, c.instructorId, 
                        list.filter(item => item.combineInsNm === c.combineInsNm).map(item => item.classNo), 
                        e.target.checked, e)} />
                  </td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };


  return (
    <>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onClose}
        overlayClassName="modal-overlay"
        className="modal-wrap"
      >
      <div className="modal-container" style={containerStyle}>
        <div className="modal-header" style={{ cursor: "move" }}>
          <h5>강사 목록</h5>
          <button type="button" className="modal-btn-close" onClick={onClose}>
            <span className="modal-btn-span">X</span>
          </button>
        </div>
        <div className="modal-content">
          <div style={{overflow:"auto"}}>
            {Object.keys(grouped).length ? (
            <>
              {Object.entries(grouped).map(([date, list]) =>
                renderSchedule(date, list),
              )}
            </>
            ) : null}
          </div>
        </div>
        <div className="modal-btn-wrap btn-right-box">
          <ul>
            <li><button type="button" className="btn-cancel" onClick={onClose}>닫기</button></li>

          </ul>
        </div>
      </div>
      </ReactModal>
    </>
  );
}

export { LectureInstructorModal };
